module.exports = __webpack_public_path__ + "img/fossilImg3.a473ee4b.jpg";